import * as React from 'react';

import { ServiceAds } from '../service_ads/service_ads';
import { formatMapURL } from '../../helpers/map_helper';

const s = require('./sale_item_block.css');

interface IProps {
  coordinates?: {
    lat: number;
    lng: number;
  };
  section: string;
  onAdsClick(eventLabel: string): void;
}

export const MapSearchBlock = (props: IProps) =>
  <div className={`${s['c-bottom-selfads-col']} cg-col-12`}>
    <ServiceAds
      class={`${s['c-selfads-item-map']} ${s['c-selfads-item']}`}
      onClick={() => props.onAdsClick('search_on_map')}
      title="Ищите на карте"
      description="Ищите объявления рядом с работой, парком или родственниками"
      buttonText="Найти на карте"
      buttonUrl={formatMapURL(props.coordinates, props.section)}
      isNewTab
    />
  </div>;
